<template>
  <div>
    <div class="">
      <div class="flex justify-content-between">
        <div class="flex-grow-1">
          <h3 class="mb-1">Препарат: <strong>{{
              task.task_data?.drug?.title ?? record?.drug?.title ?? task?.related_ms_drug?.title
            }}</strong></h3>
          <p><i>{{ task.task_data?.drug?.group ?? task?.related_ms_drug?.group }}</i></p>
          <h5 class="white-space-pre" v-if="task.task_data?.comment" v-html=" task.task_data.comment"/>
        </div>
        <div>
          <span class="text-muted">{{ task.id }}</span>
        </div>
      </div>
      <div v-if="false">
        <LoadingButton
          title="Сохранить задачу"
          :loading="loading"
          color="white"
          :onClick="() => saveTask()"
          className="btn btn-success"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <SimpleTaskWithComment ref="taskCommentBlock" :task="task" :updateTasks="updateTasks"/>
      </div>
      <div class="col-md-4">
        <div class="card">
          <div class="card-body">
            <template v-if="+task.status === 0">
              <LoadingButton
                title="Взять задачу в работу"
                :loading="loading"
                color="white"
                :onClick="() => saveTask(false, 'updateStatus')"
                className="btn btn-success"
              />
            </template>
            <template v-else>
              <div class="form-group">
                <label>Статус задачи</label>
                <TasksSubStatuses type="select" :task="task"
                                  :onChange="() => saveTask(false, 'updateSubStatus')"/>
              </div>
            </template>
          </div>
        </div>

        <div class="card" v-if="task.id && task.status !== 0">
          <div class="card-header bg-dark">
            <h6>Перенос даты актуальности</h6>
          </div>
          <div class="card-body">
            <ShiftTaskActualDate ref="ShiftTaskActualDate" :plus-days="30"/>
            <div class="text-right mt-1">
              <LoadingButton
                title="Сделать перенос актуальности"
                :loading="loading"
                :color="$constants.PRIMARY_COLOR"
                :onClick="() => saveTask(false, 'shiftActualDate')"
                className="btn btn-outline-info"
              />
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="text-right mt-1" v-if="allowToEdit">
      <template v-if="task.is_active">
        <LoadingButton
          title="Закрыть задачу"
          :loading="loading"
          color="white"
          :onClick="() => saveTask(false, 'closeTask')"
          className="btn btn-outline-success"
        />
      </template>
      <template v-else>
        <LoadingButton
          :title="(task?.id ? 'Возобновить' : 'Создать') + ' задачу'"
          :loading="loading"
          color="white"
          :onClick="() => saveTask(false, task?.id ? 'reActive' : 'newTask')"
          className="btn btn-success"
        />
      </template>
    </div>

    <div class="card mt-2">
      <div class="card-header bg_green">
        <h4>Выбор производителя</h4>
        <hr>
        <div class="flex justify-content-between">
          <template v-if="task.manufacturer_id">
            <div class="flex-grow-1">
              <strong>{{ selectedManufacturer?.title }}</strong>
            </div>
            <div>
              <button @click="showEditBlock = !showEditBlock" class="btn btn-default">
                {{ showEditBlock ? 'Скрыть' : 'Редактировать производителя' }}
              </button>
            </div>
          </template>
          <template v-if="!task.manufacturer_id && !showEditBlock">
            <button @click="showEditBlock = !showEditBlock" class="btn btn-default">Выбрать производителя</button>
          </template>
        </div>
      </div>
      <div class="card-body" v-if="showEditBlock">
        <EditManufacturer
          v-if="selectedManufacturer"
          :savedManufacturer="selectedManufacturer"
          :onSelectManufacturer="(m) => updateManufacturerInTask(m)"
        />
        <div class="mt-1">
          <label>Выбрать производителя</label>
          <div class="flex">
            <div class="flex-grow-1">
              <Search
                ref="search"
                :customPreset="{placeholder:'Поиск производителя'}"
                searchType="manufacturer"
                :onSelect="(m) => addNewManufacturer(m)"
              />
            </div>
            <button @click="addNewManufacturer()" type="button" class="btn btn-default">Создать нового</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import EditManufacturer from "@/components/manufacturer/EditManufacturer.vue";
import Search from "@/components/search/Search.vue";
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import SimpleTaskWithComment from "@/views/tasks/components/SimpleTaskWithComment.vue";
import {customUpdateData} from "@/eventsBus";
import ShiftTaskActualDate from "@/views/statistics/components/ShiftTaskActualDate.vue";
import TasksSubStatuses from "@/views/tasks/components/TasksSubStatuses.vue";


export default {
  components: {TasksSubStatuses, SimpleTaskWithComment, LoadingButton, Search, EditManufacturer, ShiftTaskActualDate},
  props: ['task', 'updateTasksPull', 'updateTasks', 'record'],
  data() {
    return {
      loading: false,
      showEditBlock: false,
      allowToEdit: false,
      selectedManufacturer: null,
    }
  },
  created() {
    if (this.task?.manufacturer?.id) {
      this.selectedManufacturer = {...this.task.manufacturer};
    }
    if (!this.task?.id) {
      console.log('set comment');
      setTimeout(() => {
        if (this.$refs?.taskCommentBlock?.$refs?.commentBlock) {
          // console.log('found');
          this.$refs.taskCommentBlock.$refs.commentBlock.comment = 'почему пропал и когда появится';
        }
      }, 300);
    }
    if (this.$currentRole === 'admin') this.allowToEdit = true;
  },
  methods: {
    async updateManufacturerInTask(manufacturer) {
      this.selectedManufacturer = manufacturer;
      await this.saveTask(true, 'updateManufacturer');
    },
    async saveTask(silent = false, action = 'updateTask') {
      this.loading = true;
      const data = await (async () => {
        if (action === 'closeTask' || action === 'reActive') {
          const {data} = await api.post('/tasks/' + this.task.id, {action});
          return data;
        } else if (action === 'updateStatus') {
          const {data} = await api.post('/tasks/' + this.task.id, {action, data: {status: 5}});
          return data;
        } else if (action === 'shiftActualDate' || action === 'updateSubStatus') {
          const {data} = await api.post('/tasks/' + this.task.id, {
            action, data: {
              ...this.$refs.ShiftTaskActualDate.getData(),
              return_status: this.task.status,
              sub_status: this.task.sub_status,
            }
          });
          return data;
        } else if (action === 'updateManufacturer') {
          const {data} = await api.post('/tasks/' + this.task.id, {
            action, data: {manufacturer: this.selectedManufacturer}
          });
          return data;
        } else {
          const {data} = await api.post('/tasks/stat/new', {
            record: {
              id: this.task?.id,
              drug: {
                id: this.record?.drug?.id,
                group: this.record.drug.group,
                title: this.record.drug.title,
              }
            },
            tasks: {
              storeCall: {
                comment: this.$refs?.taskCommentBlock?.$refs?.commentBlock?.comment,
                manufacturer: this.selectedManufacturer
              }
            }
          });
          return data;
        }
      })();
      if (data && data?.success) {
        if (this.$refs?.taskCommentBlock?.$refs?.commentBlock?.comment) {
          this.$refs.taskCommentBlock.$refs.commentBlock.comment = null;
        }
        if (this.record?.id) {
          customUpdateData.$emit('updateListById', this.record.id);
        } else {
          if (this.updateTasks) {
            this.updateTasks();
          }
        }
        if (!silent) toastr['success']('сохранено', 'Успешно');
        this.$store.dispatch('platform/setGlobalDrawerData', null);
      } else {
        toastr['warning']((data && data?.message) ?? 'Ошибка сервера');
      }
      this.loading = false;
    },
    async addNewManufacturer(manufacturer = {}) {
      this.selectedManufacturer = null;
      this.$refs.search.selected = null;
      await this.$nextTick();
      this.selectedManufacturer = manufacturer;
      // if (manufacturer?.id) this.saveTask();
    }
  }
}

</script>

<style scoped>
.bg_green,
.bg_green .card-header {
  background-color: #009e0014;
}

.white-space-pre {
  white-space: pre;
}
</style>
